import { render, staticRenderFns } from "./ViewProfileCompanyPopup.vue?vue&type=template&id=ef380656&scoped=true"
import script from "./ViewProfileCompanyPopup.vue?vue&type=script&lang=js"
export * from "./ViewProfileCompanyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef380656",
  null
  
)

export default component.exports